const SubscriptionRoutes = {
    createSubscription: 'admin/plan',
    getSubscriptions: 'plan/',
    updateSubscription: 'admin/plan',
    deleteSubscription: 'admin/plan/',
};

export default SubscriptionRoutes